import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import { HieroglyphRain } from "../GameObjects/HieroglyphRain";
import { HieroglyphWind } from "../GameObjects/HieroglyphWind";

export enum WeatherType {
    DAY,
    RAIN,
    WIND,
    NIGHT,
    NUM_ELEMENTS,
}

export class HieroglyphWeather extends PIXI.Container {
    private _weatherMask: PIXI.Graphics;
    private _wind: HieroglyphWind;
    private _rain: HieroglyphRain;
    private _type: WeatherType;
    private _night: PIXI.Sprite;

    constructor() {
        super();
        this._type = WeatherType.DAY;

        this._wind = new HieroglyphWind();
        this.addChild(this._wind);

        this._rain = new HieroglyphRain();
        this.addChild(this._rain);

        this._night = HLF.PixiUtils.makeSprite("night-overlay", Constants.SPRITESHEET_HIERO_PREFIX + "03");
        this._night.scale.set(4);
        this.addChild(this._night);

        // Using a graphics mask instead of a sprite mask, due to positioning issues on mobile iOS
        this._weatherMask = new PIXI.Graphics();
        this._weatherMask.beginFill(0x000000);
        this._weatherMask.drawRect(-345, -230, 690, 460);
        this._weatherMask.endFill();
        this.addChild(this._weatherMask);
        this.mask = this._weatherMask;

        this.setWeather(this._type);
    }

    public get weatherIndex(): number {
        return this._type;
    }

    public update(pDeltaTime: number): void {
        this._wind.update(pDeltaTime);
        this._rain.update(pDeltaTime);
    }

    public setWeather(pIndex: number, pInstantly: boolean = false): void {
        this._type = pIndex;
        this._wind.visible = pIndex === WeatherType.WIND;
        this._rain.visible = pIndex === WeatherType.RAIN;
        this._night.visible = pIndex === WeatherType.NIGHT;
    }
}
